
export { Box } from "/vercel/path0/styled-system/jsx/box.mjs"